export default "__VITE_ASSET__gPAyOtQe__"